import React, { useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import * as appActions from "../../core/app.store";
import * as config from '../../common/config'

import headCellsListFeedback from './head-cell-list-feedback';
import DataTableSarang from '../../components/datatable-sarang';

import viVN from "../../language/vi-VN.json";
import { NotificationMessageType, getUserInfo, MediaUrl } from "../../utils/configuration";
import ShowNotification from "../../components/react-notifications/react-notifications";

import * as feedbackManagementAction from "../../redux/store-sarang/feedback/feedback-management.store";

import ModalSubmitForm from '../../components/sarang-modals/modal-submit-form/modal-submit-form';
import dayjs from 'dayjs';
import ModalConfirm from '../../components/sarang-modals/modal-confirm/modal-confirm';

import FormAddEditFeedback from './components/form-add-edit-feedback';
import FormReplyFeedback from './components/form-reply-feedback';

const configLocal = {
    defaultPageSize: config.Configs.DefaultPageSize,
    sortExpression: "createdDate desc",
    orderBy: "createdDate",
    order: "desc",
}

export default function FeedbackList() {
    const dispatch = useDispatch();
    const showLoading = (data) => dispatch(appActions.ShowLoading(data));

    // -- Data to map with ids

        // -- End Data to map with ids

    const [data, setData] = useState([])
    const [totalItemCount, setTotalItemCount] = useState(0);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(configLocal.defaultPageSize);
    const [order, setOrder] = useState(configLocal.order);
    const [orderBy, setOrderBy] = useState(configLocal.orderBy);
    const [user, setUser] = useState(getUserInfo());

    useEffect(() => {
        if (user?.email != "sarang@gmail.com") {
            window.location.replace("/");
        }
        getListFeedbackManagement();
    }, []);

    const getListFeedbackManagement = (pageIndex = 1, pageSize = configLocal.defaultPageSize, sortExpression = configLocal.sortExpression) => {
        showLoading(true);
        // setPage(pageIndex-1)
        feedbackManagementAction.GetListFeedback(pageIndex, pageSize, sortExpression).then(
            (res) => {
                if (res &&
                    res.content &&
                    res.content.items
                ) {
                    setData(res.content.items)
                    setTotalItemCount(res.content.totalItemCount)
                }
                showLoading(false);
            },
            (err) => {
                showLoading(false);
                err && err.errorType &&
                ShowNotification(
                    viVN.Errors[err.errorType],
                    NotificationMessageType.Error
                );
            }
        );
    }
    
    const handleRequestSort = (event, property) => {
        const isAsc = orderBy === property && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
        let sort = isAsc ? 'desc' : 'asc';
        let sortExpression = property + ' ' + sort;
        getListFeedbackManagement(page + 1, rowsPerPage, sortExpression);
        console.log(sortExpression);
    };
    
    const handleChangePage = (newPage) => {
        setPage(newPage - 1);
        let sortExpression = orderBy + ' ' + order;
        getListFeedbackManagement(newPage, rowsPerPage, sortExpression);
    };
    
    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
        let sortExpression = orderBy + ' ' + order;
        getListFeedbackManagement(1, event.target.value, sortExpression);
    };

    const handleSubmitAddEditSwat = async (data) => {
        showLoading(true);
        
        let formData = new FormData();
        for (let key in data) {
            if (data[key] !== undefined && data[key] !== null && data[key] !== '') formData.append(key, data[key]);
        }

        if (data?.herdsmanId == undefined || data?.herdsmanId == null)
            formData.append("herdsmanId", user?.herdsmanId);

        try {
            let res = null;

            if( !data.id ) {
                res = await feedbackManagementAction.CreateFeedback(formData);
            } else {
                res = await feedbackManagementAction.UpdateFeedback(formData);
            }

            if ( res && res.content ) {
                getListFeedbackManagement();
            }
            showLoading(false);
        } catch (err) {
            showLoading(false);
            err && err.errorType &&
            ShowNotification(
                viVN.Errors[err.errorType],
                NotificationMessageType.Error
            );
        }
    }
     
    const buttonOpenAddEditRef = useRef();
    const buttonOpenConfirmRef = useRef();
    const [isOpenAddEditDialog, setOpenAddEditDialog] = useState(false);
    const [isOpenReplyDialog, setOpenReplyDialog] = useState(false);
    const [isOpenDeleteDialog, setOpenDeleteDialog] = useState(false);
    const [isOpenActiveDialog, setOpenActiveDialog] = useState(false);
    const [isOpenDeactiveDialog, setOpenDeactiveDialog] = useState(false);

    const [selectedItem, setSelectedItem] = useState(null);
    const openAddDialog = () => {
        setOpenAddEditDialog(true);
        buttonOpenAddEditRef.current.click();
    };
    const openReplyDialog = (item) => {
        setOpenReplyDialog(true);
        setSelectedItem(item);
        buttonOpenAddEditRef.current.click();
    }
    const closeAddEditDialog = () => {
        setOpenAddEditDialog(false);
        setOpenReplyDialog(false);
        setSelectedItem(null);
    }
    const openConfirmDialog = (item) => {
        setSelectedItem(item);
        buttonOpenConfirmRef.current.click();
    }
    const closeConfirmDialog = () => {
        setOpenDeleteDialog(false);
        setOpenActiveDialog(false);
        setOpenDeactiveDialog(false);
        setSelectedItem(null);
    }
    const handleConfirm = async () => {
        try {
            let res = null;

            if( isOpenDeleteDialog ) {
                res = await feedbackManagementAction.DeleteFeedback(selectedItem.id);
            } else if (isOpenActiveDialog) {
                res = await feedbackManagementAction.ActiveFeedback(selectedItem.id);
            } else if (isOpenDeactiveDialog) {
                res = await feedbackManagementAction.DeActiveFeedback(selectedItem.id);
            }

            if ( res ) {
                getListFeedbackManagement();
            }
            showLoading(false);
            closeConfirmDialog();
        } catch (err) {
            showLoading(false);
            err && err.errorType &&
            ShowNotification(
                viVN.Errors[err.errorType],
                NotificationMessageType.Error
            );
        }
    }

    return (
        <div className="row">
            <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                <div className="card">
                    <div className="card-body">
                        <form>
                            <div className="row">
                                <div className="form-group col-md-6">
                                    <div className="form-group">
                                        <label htmlFor="input-name" className="col-form-label">Tên</label>
                                        <input id="input-name" placeholder="Tên" type="text" className="form-control"/>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-sm-12 pl-0">
                                    <p className="text-center">
                                        <button type="submit" className="btn btn-space btn-primary">Tìm kiếm</button>
                                        <button className="btn btn-space btn-secondary">Xóa lọc</button>
                                        <button
                                            className="btn btn-space btn-warning"
                                            onClick={(e) => {
                                                e.preventDefault();
                                                openAddDialog();
                                            }}
                                        >Thêm mới</button>
                                    </p>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
                <DataTableSarang
                    // button functions
                    rowsPerPage={rowsPerPage}
                    handleChangeRowsPerPage={handleChangeRowsPerPage}
                    // head cells
                    headCells={headCellsListFeedback}
                    handleRequestSort={handleRequestSort}
                    order={order}
                    orderBy={orderBy}
                    // pagination
                    totalItemCount={totalItemCount}
                    setRowsPerPage={setRowsPerPage}
                    pageIndex={page}
                    handleChangePage={handleChangePage}
                >
                    <tbody>
                        {
                            data.length > 0 ?
                            data.map((row, rowIndex) => (
                                <tr key={rowIndex}>
                                    <td><span>{row.herdsmanName}</span></td>
                                    <td><span>{row.title}</span>
                                        {
                                            row.documentUploadId ? <span> (<a href={MediaUrl + row.fileAttach?.filePreview} target="image">Xem ảnh</a>)</span> : <></>
                                        }</td>
                                    <td><span>{row.content}</span></td>
                                    <td>{
                                        row.children && row.children.length > 0 ? row.children.map((item, index) => <span>- {item.content}<br /></span>) : <></>
                                    }</td>
                                    <td><span>{dayjs(row.created_date).format("DD/MM/YYYY hh:mm:ss")}</span></td>
                                    <td>
                                        <div className='d-flex'>
                                            <button className="d-inline-block btn btn-xs btn-outline-success" data-toggle="tooltip" data-placement="top"
                                                title="Trả lời"
                                                onClick={(event) => {
                                                    openReplyDialog(row);
                                                }}
                                            >
                                                <i className="fas fa-list-alt"></i>
                                            </button>
                                            <button className="d-inline-block btn btn-sm btn-outline-light custom-button-table delete" data-toggle="tooltip" data-placement="top"
                                                title="Xóa"
                                                onClick={() => {
                                                    setOpenDeleteDialog(true);
                                                    openConfirmDialog(row);
                                                }}
                                            >
                                                <i className="far fa-trash-alt"></i>
                                            </button>
                                        </div>
                                    </td>
                                </tr>
                            )) :
                            <tr><td colSpan={10}>Chưa có dữ liệu</td></tr>
                        }
                    </tbody>
                </DataTableSarang>
            </div>
            <button ref={buttonOpenAddEditRef} type="button" className="d-none" data-toggle="modal" data-target="#modalSubmitForm">
                Launch modal add edit
            </button>
            <button ref={buttonOpenConfirmRef} type="button" className="d-none" data-toggle="modal" data-target="#modalConfirm">
                Launch modal confirm
            </button>
            <ModalSubmitForm
                title={isOpenReplyDialog ? "Trả lời" : !selectedItem ? "Thêm mới Bộ" : "Chỉnh sửa Bộ"}
                open={isOpenAddEditDialog || isOpenReplyDialog}
                onClose={closeAddEditDialog}
            >
                {
                    isOpenReplyDialog ? <FormReplyFeedback
                        updateItem={selectedItem}
                        onSubmitAddEdit={handleSubmitAddEditSwat}
                    /> : <FormAddEditFeedback
                        updateItem={selectedItem}
                        onSubmitAddEdit={handleSubmitAddEditSwat}
                    />
                }
            </ModalSubmitForm>

            <ModalConfirm 
                title={"Xác nhận"}
                prompt={
                    isOpenDeleteDialog ? "Bạn có chắc chắn muốn xóa bản ghi này không?":
                    isOpenActiveDialog ? "Bạn có chắc chắn muốn mở khóa bản ghi này không?":
                    isOpenDeactiveDialog ? "Bạn có chắc chắn muốn khóa bản ghi này không?": ""
                }
                open={isOpenDeleteDialog || isOpenActiveDialog || isOpenDeactiveDialog }
                onClose={closeConfirmDialog}
                onConfirm={handleConfirm}
            />
        </div>
    )
}